(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pet-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pet-delivery')) {
    customElements.define(
      'pet-delivery',
      class extends HTMLElement {
        connectedCallback() {
          this.render();
          this.timer = setInterval(() => this.render(), 60000);
        }
        disconnectedCallback() {
          clearInterval(this.timer);
        }
        addBusinessDays(date, days) {
          const d = new Date(date);
          let added = 0;
          while (added < days) {
            d.setDate(d.getDate() + 1);
            const day = d.getDay();
            if (day !== 0 && day !== 6) added++;
          }
          return d;
        }
        render() {
          const now = new Date();
          const cutoff = parseInt(this.dataset.cutoff, 10);
          const processing = parseInt(this.dataset.processing, 10) || 0;
          const min = parseInt(this.dataset.min, 10) || 0;
          const max = parseInt(this.dataset.max, 10) || min;
          const isWeekend = now.getDay() === 0 || now.getDay() === 6;
          const pastCutoff = now.getHours() >= cutoff;
          const extra = isWeekend || pastCutoff ? 1 : 0;
          const shipDays = processing + extra;
          const start = this.addBusinessDays(now, shipDays + min);
          const end = this.addBusinessDays(now, shipDays + max);
          const fmt = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
          const range = this.querySelector('[data-range]');
          if (range) range.textContent = min === max ? fmt.format(start) : `${fmt.format(start)} – ${fmt.format(end)}`;
          const countdown = this.querySelector('[data-countdown]');
          const template = this.dataset.countdownTemplate;
          if (countdown && template && !isWeekend && !pastCutoff) {
            const diff = new Date(now).setHours(cutoff, 0, 0, 0) - now;
            const h = Math.floor(diff / 3600000);
            const m = Math.floor((diff % 3600000) / 60000);
            countdown.textContent = template.replace('[time]', h > 0 ? `${h}h ${m}m` : `${m}m`);
            countdown.hidden = false;
          } else if (countdown) {
            countdown.hidden = true;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
